<!-- <mat-toolbar color="primary">
    <span>My Application</span>
    <app-lang-switch></app-lang-switch>
</mat-toolbar> -->
@if (isLoading()) {

<div class="loading-wrapper">
  <div class="loading">
    <img src="assets/logo-hydrao.svg" width="300px" />
    <div class="loader"></div>
    <div class="label"><span i18n>loading</span></div>
  </div>
</div>
} @else {
<router-outlet></router-outlet>
}
